import styled, {css} from 'styled-components'

export const StyledTreatmentRequestScoreRow = styled.div`
    display: grid;
    grid-template-columns: 180px auto;
    align-items: center;
`

export const StyledTreatmentRequestScoreRowLabel = styled.h3(
    ({theme: {typography}}) => css`
        ${typography.textSm};
    `
)
